<template>
  <div id="app">
      <div class="background" id="background1"></div>
      <div class="background" id="background2"></div>
      <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  data () {
    return {
    }
  },
  created: function () {
    var element = document.getElementById("noes7").remove();
  }
}
</script>

<style>
body{
  background-color: #fafafa;
  height: 0;
}
#app{
    background-color: #fafafa;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -10;
}
.background{
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: -10;
   
  }

  #background1{
      background: url("/static/img/background1.jpg") no-repeat bottom left;
  }

  #background2{
      background: url("/static/img/background2.jpg") no-repeat top right;
  }
  @media (max-width: 700px)
  {
    #background2 {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue